import { Skeleton } from 'v5/design-system/Skeleton';
import { SidebarHeader } from 'v5/patterns/sidebar/Sidebar';
import { cn } from 'v5/platform/dom/cn';

/** Header block while enterprise workspaces (or feature flag) are loading. */
export function EnterpriseMainSidebarHeaderSkeleton({
  className,
  includeActions = true
}: {
  className?: string;
  /** When false, only icon + workspace switcher placeholders (search/create stay visible). */
  includeActions?: boolean;
}) {
  const content = (
    <>
      <div className="flex items-center justify-between ml-3">
        <div className="flex items-center gap-2 flex-1">
          <Skeleton className="size-8 rounded-md shrink-0" />
          <Skeleton className="h-8 w-20 rounded-md shrink-0" />
        </div>
        <Skeleton className="size-8 rounded-md shrink-0 mr-2" />
      </div>
      <Skeleton className="h-8 w-36 rounded-md ml-3" />
      {includeActions ? (
        <div className="flex flex-row gap-2">
          <Skeleton className="h-8 flex-1 rounded-md" />
          <Skeleton className="h-8 w-[4.75rem] rounded-md shrink-0" />
        </div>
      ) : null}
    </>
  );

  if (includeActions) {
    return (
      <SidebarHeader
        className={cn('flex flex-col gap-2 min-h-(--header-height)', className)}
      >
        {content}
      </SidebarHeader>
    );
  }

  return (
    <div
      className={cn('flex flex-col gap-2 min-h-(--header-height)', className)}
    >
      {content}
    </div>
  );
}
